import { ChipProps } from "../../types";
import { MyChip, ChipText } from "./Chip.styles";

function Chip(props: ChipProps) {
  const { chip, onCloseChip } = props;
  return (
    <MyChip>
      <ChipText>{chip}</ChipText>
      <svg
        style={{ margin: "0 10px 0 -8px", cursor: "pointer" }}
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onCloseChip}
      >
        <g clip-path="url(#clip0_7518_9975)">
          <path
            d="M6 6L2 10M2 2L6 6L2 2ZM10 10L6 6L10 10ZM6 6L10 2L6 6Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7518_9975">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </MyChip>
  );
}

export default Chip;
